module.exports = __webpack_public_path__ + "img/med-insights.Actics.65f6dbbc.png";